import * as z from "zod";

/** Who an admin list row belongs to; null once the account is deleted. */
export const PlatformUserRefSchema = z.object({ name: z.string(), email: z.string() }).nullable();
export type PlatformUserRef = z.infer<typeof PlatformUserRefSchema>;

/** Read-only operator accesses recorded in the audit log. Every other action is a change. */
export const PLATFORM_VIEW_ACTIONS = [
  "audit.list",
  "commercial.settings.read",
  "computers.list",
  "incidents.list",
  "model.read",
  "models.read",
  "nodes.list",
  "orders.list",
  "plans.list",
  "requests.calls",
  "requests.list",
  "users.list",
  "voice.read",
  "web.configuration.read",
  "web.request.content",
  "web.requests.list",
] as const;

export const PLATFORM_CHANGE_ACTIONS = [
  "commercial.settings.save",
  "incidents.acknowledge",
  "integrations.save",
  "model.default.set",
  "model.routing.save",
  "model.save",
  "nodes.cancel",
  "nodes.drain",
  "nodes.enroll",
  "nodes.resume",
  "nodes.retry",
  "nodes.storage-oversell",
  "plans.save",
  "roles.bootstrap",
  "roles.set",
  "users.suspend",
  "voice.save",
  "web.configuration.save",
] as const;

export const PlatformAuditKindSchema = z.enum(["change", "view", "all"]);
export type PlatformAuditKind = z.infer<typeof PlatformAuditKindSchema>;

export const PlatformRequestUsageSchema = z.object({
  inputTokens: z.number(),
  outputTokens: z.number(),
  cacheReadTokens: z.number(),
  cacheWriteTokens: z.number(),
  totalTokens: z.number(),
  calls: z.number(),
});
export type PlatformRequestUsage = z.infer<typeof PlatformRequestUsageSchema>;
